(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner"] && !Shopify.designMode) return;
  try {
    
class PromoBanner extends HTMLElement {
  connectedCallback() {
    this._closeBtn = this.querySelector('[data-promo-close]');
    this._countdownEl = this.querySelector('[data-countdown]');

    if (this._closeBtn) {
      this._closeBtn.addEventListener('click', this._dismiss.bind(this));
    }

    if (this._countdownEl) {
      this._initCountdown();
    }
  }

  _dismiss() {
    this.setAttribute('hidden', '');
    try {
      sessionStorage.setItem('promo-banner-dismissed', 'true');
    } catch (_) {}
  }

  _initCountdown() {
    const endDateStr = this._countdownEl.dataset.countdown;
    if (!endDateStr) return;

    const endDate = new Date(endDateStr);
    if (isNaN(endDate.getTime())) return;

    const daysEl = this.querySelector('[data-days]');
    const hoursEl = this.querySelector('[data-hours]');
    const minutesEl = this.querySelector('[data-minutes]');
    const secondsEl = this.querySelector('[data-seconds]');

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    const pad = function(n) { return String(Math.max(0, n)).padStart(2, '0'); };

    const tick = () => {
      const diff = endDate.getTime() - Date.now();

      if (diff <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        clearInterval(this._timer);
        return;
      }

      const totalSec = Math.floor(diff / 1000);
      daysEl.textContent = pad(Math.floor(totalSec / 86400));
      hoursEl.textContent = pad(Math.floor((totalSec % 86400) / 3600));
      minutesEl.textContent = pad(Math.floor((totalSec % 3600) / 60));
      secondsEl.textContent = pad(totalSec % 60);
    };

    tick();
    this._timer = setInterval(tick, 1000);
  }

  disconnectedCallback() {
    if (this._timer) clearInterval(this._timer);
  }
}

if (!customElements.get('promo-banner')) {
  customElements.define('promo-banner', PromoBanner);
}

  } catch(e) { console.error(e); }
})();
})();
